import { ArrowBack } from "@mui/icons-material";
import { Box, Typography, Button, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import GraduatedResClientFormContext from "./graduated-res-client-form-context";
import { useContext, useEffect, useState } from "react";
import { clientConfig, SetS3Config } from "../../awsClientConfig";
import { userAccountData, userProfileData } from "../../Common/profileInfo";
import { CompleteProfileForm } from "../../queries/CompleteProfileForm";
import SignatureCanvas from "react-signature-canvas";
import { Storage } from "aws-amplify";
import Message from "../Message";
import { FileDropzone } from "../core/file-dropzone";
import { v4 as uuidv4 } from "uuid";
import { ItemRow } from "../TaxShield/file-storage/item-row";
import { Item } from "../TaxShield/file-storage/types";
import { createEnrollmentAction } from "../../queries/CreateEnrollmentAction";
import { StorageProvider } from "../TaxShield/file-storage/storage-context";
import { StorageView } from "../TaxShield/file-storage/storage-view";
import Loading from "../../Common/Loading";

const GovernmentIdUploadForm = () => {

    const { next, setNextFormId, enrollmentId, setS3Bucket, setS3Key, previous} = useContext(
      GraduatedResClientFormContext
      );
      const client = new clientConfig();
      const [images, setimages] = useState<Item[]>([]);
      const [buttonDisable, setButtonDisable] = useState(false);
      const [loading, setLoading] = useState(false);
      
      useEffect(() => {
        loadImages();
      }, []);

      const handleChange = async (files: any[]) => {
        /*if (images.length === 3) {
          setError("Only 3 Images are allowed");
          return;
        }*/
        setLoading(true);
        const extension = getExtension(files[0].name);
        const ispdf = isPdf(files[0].name);
        let contentType = ispdf ? "application/pdf" : "image/png";
        SetS3Config(
          `documents-${process.env.REACT_APP_MODE}-optima-financial-group`,
          "public"
        );
    
        const profileId = await userProfileData();
        const accountId = await userAccountData();
        const uuid = uuidv4();
    
        try {
          await Storage.put(
            `Accounts/${accountId}/Profiles/${profileId}/Identifications/${uuid}.${extension}`,
            files[0],
            {
              contentType: contentType, // contentType is optional
              customPrefix: { public: "" },
              tagging: "ExternalClearance=Profile",
            }
          ).then((res) => {
            console.log(res);
            loadImages();
          });
        } catch (error) {
          console.log("Error uploading file: ", error);
          setLoading(false);
        }
      };

      const loadImages = async () => {
        SetS3Config(
          `documents-${process.env.REACT_APP_MODE}-optima-financial-group`,
          "public"
        );
    
        const profileId = await userProfileData();
        const accountId = await userAccountData();
        try {
          await Storage.list(
            `Accounts/${accountId}/Profiles/${profileId}/Identifications/`,
            {
              // contentType: "image/png", // contentType is optional
              customPrefix: { public: "" },
              level: "public",
              // tagging: "ExternalClearance=Profile",
            }
          ).then((res) => {
            console.log(res);
            getImages(res.results);
            setLoading(false);
          });
        } catch (error) {
          console.log("Error uploading file: ", error);
          setLoading(false);
        }
      };
    
      const getImages = async (url: any) => {
        SetS3Config(
          `documents-${process.env.REACT_APP_MODE}-optima-financial-group`,
          "public"
        );
        let getAllImages: any = [];
        url.forEach((element: any) => {
          getAllImages.push(loadSingleImage(element));
        });
        Promise.all(getAllImages).then((values) => {
          setimages(values);
        });
      };
    
      const loadSingleImage = async (url: any) => {
        const ispdf = isPdf(url.key);
        let contentType = ispdf ? "application/pdf" : "image/png";
        const imageData: string = await Storage.get(url.key, {
          level: "public",
          contentType: contentType,
          customPrefix: { public: "" },
        });
    
        let imageObj = {
          S3Bucket: imageData,
          Name: url.key.split("/")[5],
          S3Key: url.key,
          UpdatedAt: url.lastModified,
        };
    
        return imageObj;
      };
    
      function getExtension(filename: any) {
        var parts = filename.split(".");
        return parts[parts.length - 1];
      }
    
      function isPdf(filename: any) {
        var ext = getExtension(filename);
        switch (ext.toLowerCase()) {
          case "pdf":
            return true;
        }
        return false;
      }

      const handleRemoveImage = async (imageUrl: string) => {
        SetS3Config(
          `documents-${process.env.REACT_APP_MODE}-optima-financial-group`,
          "public"
        );
    
        try {
          await Storage.remove(imageUrl, {
            // contentType: "image/png", // contentType is optional
            customPrefix: { public: "" },
            level: "public",
            // tagging: "ExternalClearance=Profile",
          }).then((res) => {
            console.log(res);
            loadImages();
          });
        } catch (error) {
          console.log("Error uploading file: ", error);
        }
      };

      const createEnrollment = () => {
        setButtonDisable(true);
        const variables = {
          EnrollmentId: enrollmentId,
          Name: "IdentificationUploaded",
        };
    
        client
          .mutate({ mutation: createEnrollmentAction, variables: variables })
          .then((res: any) => {
            if (res.data.CreateEnrollmentAction) {
              setNextFormId(
                res.data.CreateEnrollmentAction.Enrollment?.NextForm?.Id
              );
              setS3Key(res.data.CreateEnrollmentAction.Enrollment?.NextForm?.S3Key);
              setS3Bucket(
                res.data.CreateEnrollmentAction.Enrollment?.NextForm?.S3Bucket
              );
              next();
              setButtonDisable(false);
            }
          })
          .catch((error: any) => {
            console.log('error:', error);
            setButtonDisable(false);
          });
      };

    const onDocumentDeleteHandler = (itemId: string) => {
      setimages(prevState => prevState.filter((item:Item) => item.Name !== itemId));
    }

    return (
    <Box
      sx={{
        alignItems: "flex-center",
        p: { xs: 2, md: 6, lg: 4 },
        m: { xs: 2, md: 6, lg: 4 },
      }}
    >
      <Box
        sx={{
          alignItems: "flex-center",
          pl: { xs: 2, md: 6, lg: 4 },
          pr: { xs: 2, md: 6, lg: 4 },
        }}
      >
        <Button
          variant="text"
          sx={{ color: "#212636", p: 0 }}
          onClick={previous}
        >
          {" "}
          <ArrowBack fontSize="small" /> Back
        </Button>
        <Typography variant="h5" sx={{ mt: 2 }}>
          Government ID
        </Typography>
      </Box>

      <Box
        sx={{
          p: 3,
          m: 2,
          mt: 2,
          border: "1px solid var(--mui-palette-divider)",
          borderRadius: 1,
        }}
      >
        <Box>
          <Typography variant="body2" sx={{fontWeight: 'bold'}}>{'Please upload a picture of your government ID (State Issued Drivers License/ID, or Passport).'}</Typography>
          <Typography variant="body2" sx={{fontWeight: 'bold', mt:2}}>{'Please check the following to make sure your document can be processed:'}</Typography>
          <ul>
            <li><Typography variant="body2" sx={{mt: 1}}>{'The image is clear and not blurry (including your photo and/or barcode)'}</Typography></li>
            <li><Typography variant="body2">{'All information is visible (e.g., expiration date)'}</Typography></li>
            <li><Typography variant="body2">{'The document is not captured at an angle'}</Typography></li>
          </ul>
        </Box>
        <Box>
        <Box sx={{ mx: 1, my: 5 }}>
          <StorageProvider items={images}>
            <StorageView view={'list'} refreshOnDelete={onDocumentDeleteHandler}/>
          </StorageProvider>
          </Box>
          {loading?<Loading /> : <FileDropzone accept={{ '*/*': [] }} onDrop={handleChange} /> }
        </Box>
        <Box className="d-flex justify-content-end mt-2">
          <Button className="me-2 text-button">Cancel</Button>
          <Button
            onClick={createEnrollment}
            disabled={buttonDisable}
            className="option-primary-button"
          >
            Continue
          </Button>
        </Box>
      </Box>
    </Box>
    )
}

export default GovernmentIdUploadForm;